namespace GeniuzPOS.ReportMasterData {
    export interface Report_1201_DtRow {
        Id?: number;
        DocNo?: string;
        LineItemNo?: number;
        LineItemType?: string;
        ItemDesc?: string;
        RefLineItemNo?: number;
        PosFg?: number;
        PluCode?: string;
        SellUnit?: string;
        Qty?: number;
        SerialNo?: string;
        UnitPrice?: number;
        ExPrice?: number;
        DiscPc?: number;
        Discamt?: number;
        DiscCouponType?: string;
        DiscCouponNo?: string;
        PromoId?: string;
        ChargePc?: number;
        ChargeAmt?: number;
        ItemVatType?: string;
        ItemPromoFg?: number;
        ItemPromoId?: string;
        ItemDiscount?: number;
        ItemCharge?: number;
        ItemNetExprice?: number;
        AllocatedBillDiscount?: number;
        ItemNetSales?: number;
        ItemVatRate?: number;
        ItemVat?: number;
        QtyRefund?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace Report_1201_DtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'ReportMasterData.Report_1201_Dt';
        export const lookupKey = 'Report_1201_DtRow';

        export function getLookup(): Q.Lookup<Report_1201_DtRow> {
            return Q.getLookup<Report_1201_DtRow>('Report_1201_DtRow');
        }
        export const deletePermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const insertPermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const readPermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const updatePermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            LineItemNo = "LineItemNo",
            LineItemType = "LineItemType",
            ItemDesc = "ItemDesc",
            RefLineItemNo = "RefLineItemNo",
            PosFg = "PosFg",
            PluCode = "PluCode",
            SellUnit = "SellUnit",
            Qty = "Qty",
            SerialNo = "SerialNo",
            UnitPrice = "UnitPrice",
            ExPrice = "ExPrice",
            DiscPc = "DiscPc",
            Discamt = "Discamt",
            DiscCouponType = "DiscCouponType",
            DiscCouponNo = "DiscCouponNo",
            PromoId = "PromoId",
            ChargePc = "ChargePc",
            ChargeAmt = "ChargeAmt",
            ItemVatType = "ItemVatType",
            ItemPromoFg = "ItemPromoFg",
            ItemPromoId = "ItemPromoId",
            ItemDiscount = "ItemDiscount",
            ItemCharge = "ItemCharge",
            ItemNetExprice = "ItemNetExprice",
            AllocatedBillDiscount = "AllocatedBillDiscount",
            ItemNetSales = "ItemNetSales",
            ItemVatRate = "ItemVatRate",
            ItemVat = "ItemVat",
            QtyRefund = "QtyRefund",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
